import React from 'react';
import { Box, Grid, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';

const SingleSelectionAck = ({
    payerReference,
    payoutCurrency,
    payoutAmount,
    showFxRate,
    showPaypalEmail,
    paypalEmail,
    showBankDetails,
    bankDisplayValue,
    addressDisplayValue,
    fxRate,
}) => {
    const { t } = useTranslation();
    return (
        <Grid container component='dl'>
            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginBottom={2}>
                        <Typography variant='body1'>{t('acknowledgementPage.transaction')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginLeft='20px'>
                        <Typography variant='body1' id='ack-typo-payerReference'>
                            {payerReference}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginBottom={2}>
                        <Typography variant='body1'>{t('acknowledgementPage.payment_amount')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginLeft='20px'>
                        <Typography variant='body1' id='ack-typo-payout-currencyAmount'>
                            {payoutCurrency}&nbsp;{payoutAmount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            {showFxRate ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginBottom={2}>
                            <Typography variant='body1'>{t('acknowledgementPage.rate_used')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px'>
                            <Typography variant='body1' id='ack-typo-fxRate'>
                                {fxRate}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showBankDetails ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginBottom={['10px', '10px', '10px', '24px']}>
                            <Typography variant='body1'>{t('acknowledgementPage.bank_Account_details')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginBottom={['10px', '10px', '10px', '24px']} marginLeft='20px'>
                            <Typography variant='body1' id='verify-typo-bankDetails'>
                                {bankDisplayValue}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showPaypalEmail ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginBottom={['10px', '10px', '10px', '24px']}>
                            <Typography variant='body1'>{t('acknowledgementPage.paypal_Account_details')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px' marginBottom={['10px', '10px', '10px', '24px']}>
                            <Typography variant='body1' id='ack-typo-paypalEmail'>
                                {paypalEmail}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default SingleSelectionAck;
